import { isolateComponent, labelStyles } from '@zapier/style-encapsulation';
import { css } from '@emotion/react';
import { Children } from 'react';
const breakpoints = {
    tablet: 768,
    desktop: 1230,
};
const Styles = labelStyles('BlockGrid', {
    root: ({ childrenLength, maxColumns, maxWidth, }) => css `
    display: grid;
    align-items: flex-start;
    gap: 50px 30px;
    max-width: ${maxWidth}px;
    margin: auto;
    grid-template-columns: repeat(${childrenLength}, 1fr);

    // Two columns if tablet and two children, otherwise one column.
    @media screen and (max-width: ${breakpoints.desktop}px) {
      grid-template-columns: repeat(
        ${childrenLength === 2 || maxColumns === 2 ? 2 : 1},
        1fr
      );
    }

    // One column if mobile
    @media screen and (max-width: ${breakpoints.tablet}px) {
      grid-template-columns: repeat(1, 1fr);
    }
  `,
});
export const BlockGrid = ({ children, maxColumns, maxWidth = 1170 }) => {
    const childrenLength = maxColumns || Children.toArray(children).length;
    return (isolateComponent("div", { css: Styles.root({ childrenLength, maxColumns, maxWidth }) }, children));
};
//# sourceMappingURL=BlockGrid.js.map
// @zapier/design-system@6.14.1 (10126c41d)
